/*
 * Code generated by Speakeasy (https://speakeasy.com). DO NOT EDIT.
 */

import * as z from "zod/v4-mini";
import { safeParse } from "../../lib/schemas.js";
import { Result as SafeParseResult } from "../../types/fp.js";
import { SDKValidationError } from "../errors/sdkvalidationerror.js";

/**
 * One scalar drift between the decision's evidence snapshot and the current gather.
 */
export type EvidenceFieldChange = {
  /**
   * The value the latest gather found.
   */
  after: string;
  /**
   * The value the decision rested on.
   */
  before: string;
  /**
   * Which fact moved: authority_mode, dynamic_registration, or known_advisories.
   */
  field: string;
};

/** @internal */
export const EvidenceFieldChange$inboundSchema: z.ZodMiniType<
  EvidenceFieldChange,
  unknown
> = z.object({
  after: z.string(),
  before: z.string(),
  field: z.string(),
});

export function evidenceFieldChangeFromJSON(
  jsonString: string,
): SafeParseResult<EvidenceFieldChange, SDKValidationError> {
  return safeParse(
    jsonString,
    (x) => EvidenceFieldChange$inboundSchema.parse(JSON.parse(x)),
    `Failed to parse 'EvidenceFieldChange' from JSON`,
  );
}
